import { BOT_PATTERN } from 'settings/bot';

export function isBot(): boolean {
  const regex = new RegExp(BOT_PATTERN, 'i');
  const userAgent = navigator.userAgent.toLowerCase();

  return regex.test(userAgent);
}
